/** @format */

import React from 'react';
import { PageContainer } from 'components';
import { CommonProvider } from 'providers';
import { Content } from './components';
import ImprestFunderReportSummary from './components/ImprestFunderReportSummary';
import { constBreadCrumbsTitle } from 'utility';
import { useCurrencyUnit } from 'hooks';


const ImprestFunderReport = () => {
  const currencyText = useCurrencyUnit(false);

  const hint = 'در این بخش می‌توانید گزارش کلی تنخواه دار و تنخواه گردان را مشاهده نمایید. جهت نمایش لیست، پس از انتخاب بازه زمانی مورد نظر بر روی دکمه جستجو کلیک نمایید.';
  return (
    <>
      <PageContainer
        title="گزارش  کل تنخواه"
        pageKey="ImprestFunderReport"
        description={hint}
        breadcrumbs={constBreadCrumbsTitle.FUNDER_IMPREST_REPORT}>
        <CommonProvider>
          <Content currencyText={currencyText}/>
        </CommonProvider>
      </PageContainer>
      <ImprestFunderReportSummary currencyText={currencyText} />
    </>
  );
};

export default ImprestFunderReport;
